import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { SearchHouseAddress } from '../Optics/LoadingData/LoadingDataTerritory';
import { WriteHousesEntranceCoordinate } from '../Optics/WriteData/WriteHouseEntrancesCoordinates';
import L from 'leaflet';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';

// Компонент для обновления центра и зума карты
const ChangeMapCenter = ({ center, zoom }) => {
  const map = useMap();
  map.setView(center, zoom); 
  return null;
};



const ModalAddHouse = ({ open, onClose, searchAddress }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const initialCoordinates = ''; 
  const [coordinates, setCoordinates] = useState(initialCoordinates); 
  const [center, setCenter] = useState([50.4488, 30.5255]); 
  const [zoom, setZoom] = useState(7); 
  const [houseId, setHouseId] = useState(''); 
  const [house, setHouse] = useState([]);
  const [markers, setMarkers] = useState([]); 
  const houseData = house.length > 0 ? house[0] : null;
  const [mapType, setMapType] = useState('osm');

  const toggleMap = () => {
    setMapType(prev => (prev === 'osm' ? 'esri' : 'osm'));
  };

 
  // Обработчик изменения текста в поле ввода координат
  const handleInputChange = (e) => {
    setCoordinates(e.target.value || ''); 
  };

  // Обработчик изменения текста в поле ввода ID дома
  const handleHouseIdChange = (e) => {
    setHouseId(e.target.value);
  };

  const addMarker = (e) => {
    if (markers.length < houseData.entrances) {
      const newMarker = {
        position: e.latlng,
        entrance: markers.length + 1,
      };
      setMarkers([...markers, newMarker]);
    } else {
      showSnackbar(`Количество маркеров не может превышать количество подъездов в доме!`, 'snackbarWarning');
    }
  };

  // Функция для обновления центра карты
  const updateCenter = () => {
    const coords = coordinates.split(',').map(coord => parseFloat(coord.trim()));
    
    if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1]) && houseId.trim() !== '') {
      setCenter([coords[0], coords[1]]); 
      setZoom(18); 
      SearchHouseAddress(houseId, setHouse );
    } else {
      showSnackbar(`Введите корректные координаты в формате "50.4488, 30.5255" и укажите ID дома!`, 'snackbarWarning');
    }
  };

  // Обработчик закрытия окна
  const handleClose = () => {
    setCoordinates(initialCoordinates); 
    setCenter([50.4488, 30.5255]); 
    setZoom(7); 
    setHouseId(''); 
    setHouse([]);
    setMarkers([]); 
    onClose();
  };

  // Обработчик для создания массива данных маркеров
  const handleGenerateData = () => {
    if (markers.length === houseData.entrances) {
      WriteHousesEntranceCoordinate(markers, houseData.id, houseData.entrances, showSnackbar, searchAddress);
    } else {
      showSnackbar(`Некорректное количество маркеров. Ожидается ${houseData.entrances}, но установлено ${markers.length}.`, 'snackbarWarning');
    }
  };

  // Обработчик удаления маркера
  const handleRemoveMarker = (indexToRemove) => {
    const updatedMarkers = markers.filter((_, index) => index !== indexToRemove);
    setMarkers(updatedMarkers);
  };

  const MapEvents = () => {
    useMapEvents({
      click(e) {
        addMarker(e);
      },
    });
    return null;
  };


 

  return (
    <Dialog open={open} className="modalStyleUpTer">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Ручная актуализация дома</label>
        <hr className='horizontalLineModalUpTer' />
        
        <input 
          className='inputAuth'
          type="number"
          placeholder="ID дома" 
          value={houseId} 
          onChange={handleHouseIdChange}
        />
        
        <input 
          className='inputAuth'
          type="text"
          placeholder="Введите координаты" 
          value={coordinates} 
          onChange={handleInputChange}
        />
        
        <button onClick={updateCenter} className='buttonIsHideModalUpTer' style={{ marginBottom: '10px', padding: "10px" }}>
          Поиск
        </button>

        <hr className='horizontalLineModalUpTer' />
        {houseData && (
          <>
            <label style={{ color: 'orange' }}>
              Адрес: <span style={{ color: '#c5c5c5' }}>ул. {houseData.street}, дом: {houseData.houseNumber}</span>
            </label>
            <br />
            <label style={{ color: 'orange' }}>
              Подъездов: <span style={{ color: '#c5c5c5' }}>{houseData.entrances}</span>
            </label>
          </>
        )}

<button
            onClick={toggleMap}
            className='buttonIsHideModalUpTer'
            style={{
              position: 'absolute', // или 'fixed', если хочешь, чтобы кнопка была фиксированной на экране, даже при прокрутке
              top: '10px',
              right: '30px',
              zIndex: 1000,
            
            }}
          >
            {mapType === 'osm' ? 'Карта Esri' : 'Карта OSM'}
          </button>
        <hr className='horizontalLineModalUpTer' />
        
        <div style={{ height: '400px', width: '100%', borderRadius: '10px', marginTop: '10px' }}>
          <MapContainer
            center={center}
            zoom={zoom} 
            minZoom={12}
            style={{ height: '100%', width: '100%', borderRadius: "10px" }}
          
            
          >
             {mapType === 'osm' ? (
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
        ) : (
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            attribution='Tiles © Esri'
            maxZoom={19}
          />
        )}
       
            <ChangeMapCenter center={center} zoom={zoom} />
            <MapEvents />
            {markers.map((marker, index) => (
              <Marker key={index} position={marker.position}
                 icon={L.icon({ iconUrl: './entrance.png', iconSize: [30, 30], iconAnchor: [15, 15] })}
                 >
                <Popup className="custom-popupUpTer">
                <label style={{color: "#424242"}}> Подъезд: <span style={{color: "black"}}> {marker.entrance}</span></label>
                  <br />
                  <button 
                    onClick={(e) => { e.stopPropagation(); handleRemoveMarker(index); }}
                   className="popupButtonDeleteUpTer"
                  >
                    Удалить маркер
                  </button>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        {houseData && (
          <button 
            onClick={handleGenerateData} 
            className='buttonIsHideModalUpTer'
            style={{ marginTop: '10px' }}
          >
            Отправить на сервер
          </button>
        )}


        
        <hr className='horizontalLineModalUpTer' />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>
       {/* Snackbar */}
       <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? 'orange' : 'orange'
            }
          }}
        />
    </Dialog>
  );
};

export default ModalAddHouse;